<template>
	<div>
		<div class="row">
			<div class="col-lg-12 mb-3">
				<b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
				<b-card :header="$t('general.welding.revision.title')" header-tag="h3" class="bg-default-card">
					<revision-control-table ref="rt" actionWidth='90px' @pressEdit="onEditRow" @pressDelete="onDeleteRow" @pressAdd="onAddRow" @pressReturn="onReturn">
						<span slot="return">
							{{$t('general.buttons.return_to.return_to_weld')}}
						</span>
						<span slot="add">
							{{ $t('general.welding.revision.create_button') }}
						</span>
					</revision-control-table>
				</b-card>
			</div>
		</div>

		<b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="editModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_revisions'], ['update']))">
			<div class="row">
				<div class="col-lg-6">
					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.weld_no') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.weld_no"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.spool_no') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedSpool"
								:options="currentSpool"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isSpoolLoading"
								:preserve-search="true"
								placeholder=""
								label="spool_no" track-by="id"
								:selectLabel="''"
								@search-change="onSpoolSearch"
								@input="updateSpool"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedSpool != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedSpool"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_place') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.weld_place">
                                <option v-for="weld_place in weld_places" :value="weld_place.name" :key="weld_place.name">{{weld_place.name}}</option>
                            </select>
                        </div>
                    </div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.weld_type') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedProjectSetting"
								:options="currentProjectSetting"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isProjectSettingLoading"
								:preserve-search="true"
								placeholder=""
								label="value" track-by="id"
								:selectLabel="''"
								@search-change="onProjectSettingSearch"
								@input="updateProjectSetting"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedProjectSetting != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.weld_size') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.weld_size">
						</div>
					</div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_standard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.weld_standard">
                                <option v-for="(value,key) in part_standard" :value="key" :key="key">{{value}}</option>
                            </select>
                        </div>
                    </div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.weld_dimension') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" class="form-control" v-model="model.weld_dimension">
						</div>
					</div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWeldMaterial"
                                :options="currentWeldMaterial"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWeldMaterialLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
								:selectLabel="''"
                                @search-change="onWeldMaterialSearch"
                                @input="updateWeldMaterial"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWeldMaterial != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWeldMaterial"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.welder1') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedWelder1"
								:options="currentWelder1"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isWelder1Loading"
								:preserve-search="true"
								placeholder=""
								label="fullname2" track-by="id"
								:selectLabel="''"
								@search-change="onWelder1Search"
								@input="updateWelder1"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWelder1 != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWelder1"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.welder_date_1') }}</label>
						</div>
						<div class="col-lg-8">
							<div class="form-control">
								<flat-pickr :config="{enableTime: true, inline: false, static: true}" class="bg-white"  v-model="model.welder_date_1"></flat-pickr>
							</div>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.welder2') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedWelder2"
								:options="currentWelder2"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isWelder2Loading"
								:preserve-search="true"
								placeholder=""
								label="fullname2" track-by="id"
								:selectLabel="''"
								@search-change="onWelder2Search"
								@input="updateWelder2"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWelder2 != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWelder2"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.welder_date_2') }}</label>
						</div>
						<div class="col-lg-8">
							<div class="form-control">
								<flat-pickr :config="{enableTime: true, inline: false, static: true}" class="bg-white"  v-model="model.welder_date_2"></flat-pickr>
							</div>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.wps') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedWps"
								:options="currentWps"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isWpsLoading"
								:preserve-search="true"
								placeholder=""
								label="wps" track-by="id"
								:selectLabel="''"
								@search-change="onWpsSearch"
								@input="updateWps"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWps != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWps"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.wpqr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input :disabled="true" class="form-control" v-model="model.wpqr">
                        </div>
                    </div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.filler_material_1') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedFillerMaterial1"
								:options="currentFillerMaterial1"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isFillerMaterial1Loading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onFillerMaterial1Search"
								@input="updateFillerMaterial1"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedFillerMaterial1 != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedFillerMaterial1"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.filler_material_2') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedFillerMaterial2"
								:options="currentFillerMaterial2"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isFillerMaterial2Loading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onFillerMaterial2Search"
								@input="updateFillerMaterial2"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedFillerMaterial2 != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedFillerMaterial2"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

                <div>
                    <div class="row mb-3" v-if="model.manual_part_description_1 == null || model.manual_part_description_1 == ''">
						<div class="col-lg-4">
							<label>{{ $t('table.part_1') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedPart1"
								:options="currentPart1"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isPart1Loading"
								:preserve-search="true"
								placeholder=""
								label="fullname" track-by="id"
								:selectLabel="''"
								@search-change="onPart1Search"
								@input="updatePart1"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedPart1 != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedPart1"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.manual_part_description_2 == null || model.manual_part_description_2 == ''">
						<div class="col-lg-4">
							<label>{{ $t('table.part_2') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedPart2"
								:options="currentPart2"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isPart2Loading"
								:preserve-search="true"
								placeholder=""
								label="fullname" track-by="id"
								:selectLabel="''"
								@search-change="onPart2Search"
								@input="updatePart2"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedPart2 != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedPart2"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.part_id_1 != null">
						<div class="col-lg-4">
							<label>{{ $t('table.project_stock_1') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedProjectStock1"
								:options="currentProjectStock1"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isProjectStock1Loading"
								:preserve-search="true"
								placeholder=""
								label="name" track-by="id"
								:selectLabel="''"
								@search-change="onProjectStock1Search"
								@input="updateProjectStock1"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedProjectStock1 != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedProjectStock1"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.part_id_2 != null">
						<div class="col-lg-4">
							<label>{{ $t('table.project_stock_2') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="selectedProjectStock2"
								:options="currentProjectStock2"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isProjectStock2Loading"
								:preserve-search="true"
								placeholder=""
								label="name" track-by="id"
								:selectLabel="''"
								@search-change="onProjectStock2Search"
								@input="updateProjectStock2"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedProjectStock2 != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedProjectStock2"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>
				</div>

				<div>
					<div class="row mb-3" v-if="model.part_id_1 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_part_description_1') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.manual_part_description_1"></textarea>
						</div>
					</div>

					<div class="row mb-3" v-if="model.part_id_2 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_part_description_2') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.manual_part_description_2"></textarea>
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_1 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_material_1') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_material_1">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_2 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_material_2') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_material_2">
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6">
				<div>
					<div class="row mb-3" v-if="model.project_stock_id_1 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_certificate_no_1') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_certificate_no_1">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_2 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_certificate_no_2') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_certificate_no_2">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_1 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_charge_no_1') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_charge_no_1">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_2 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_charge_no_2') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_charge_no_2">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_1 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_manufacturer_1') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_manufacturer_1">
						</div>
					</div>

					<div class="row mb-3" v-if="model.project_stock_id_2 == null">
						<div class="col-lg-4">
							<label>{{ $t('table.manual_manufacturer_2') }}</label>
						</div>
						<div class="col-lg-8">
							<input type="text" maxlength="50" class="form-control" v-model="model.manual_manufacturer_2">
						</div>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.repair') }}</label>
					</div>
					<div class="col-lg-8 mt-1" style="z-index: 0">
						<toggle-button v-model="model.repair" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.rt') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.rt">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.vt') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.vt">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.pt') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.pt">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.ut') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.ut">
					</div>
				</div>
				
				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.mt') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.mt">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.pmi') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.pmi">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.pwht') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.pwht">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.bht') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.bht">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.at') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.at">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.fn') }}</label>
					</div>
					<div class="col-lg-8">
						<input type="text" maxlength="50" class="form-control" v-model="model.fn">
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
						<label>{{ $t('table.others') }}</label>
					</div>
					<div class="col-lg-8">
						<textarea rows="6" maxlength="5000" class="form-control" v-model="model.others"></textarea>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-lg-4">
							<label>{{ $t('table.revision_date') }}</label>
						</div>
						<div class="col-lg-8">
							<flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"/>
						</div>
					</div>

					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.revision_number" disabled>
                        </div>
                    </div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.revision_description') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.revision_reason') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.revision_reason_setting"
								:options="currentReason"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isReasonLoading"
								:preserve-search="true"
								placeholder=""
								label="value" track-by="id"
								:selectLabel="''"
								@search-change="onReasonSearch"
							>
                               <template slot="clear" slot-scope="props">
									<div 
										v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedProjectSetting"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.revision_remarks') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<revision-control-modal :model.sync="this.model" ref="addModal" :title="actionTitle" settingType="reason_for_revision" @ok="saveAction"/>

		<confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
			{{ $t('messages.delete') }}
		</confirm-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';
import _ from 'lodash';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Multiselect from 'vue-multiselect';

import RevisionControlModal from '@/components/global/modals/RevisionControlModal.vue';
import RevisionControlTable from '@/components/global/tables/RevisionControlTable.vue';

export default {
	name: 'weld_revisioncontrol',
	components: {
		DataTable,
		ConfirmDialog,
		Multiselect,
		flatPickr,
		RevisionControlModal,
		RevisionControlTable,
	},
	data() {
		return {
			breadcrumbItems: [
				{
					text: Vue.i18n.translate('general.dashboard.title'),
					to: '/'
				},
				{
					text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
					to: '/project/'+this.$route.params.id,
				},
				{
					text: Vue.i18n.translate('general.welding.title'),
					active: true
				},
				{
					text: Vue.i18n.translate('general.welding.weld.title'),
					active: true
				},
				{
					text: Vue.i18n.translate('general.revision.title'),
					active: true
				}
			],

			model: {
				weld_no: null,
				weld_place: null,
				weld_size: null,
				weld_dimension: null,
				weld_standard: null,
				project_setting_id: null,
				weld_material_id: null,
				welder_id_1: null,
				welder_date_1: null,
				welder_id_2: null,
				welder_date_2: null,
				wps_id: null,
				spool_id: null,
				filler_material_id_1: null,
				filler_material_id_2: null,
				part_id_1: null,
				part_id_2: null,
				repair: null,
				rt: null,
				vt: null,
				pt: null,
				ut: null,
				mt: null,
				pmi: null,
				pwht: null,
				bht: null,
				at: null,
				fn: null,
				others: null,
				wpqr: null,
				signature_id_1: null,
				signature_id_2: null,
				signature_id_3: null,
				revision_number: null,
				revision_date: null,
				revision_description: null,
				revision_reason: null,
				revision_remarks: null,
				revision_reason_setting: null,
				manual_part_description_1: null,
				manual_part_description_2: null,
				manual_material_1: null,
				manual_material_2: null,
				manual_certificate_no_1: null,
				manual_certificate_no_2: null,
				manual_charge_no_1: null,
				manual_charge_no_2: null,
				manual_manufacturer_1: null,
				manual_manufacturer_2: null,
			},

			isProjectSettingLoading: false,
			isWeldMaterialLoading: false,
			isWelder1Loading: false,
			isWelder2Loading: false,
			isWpsLoading: false,
			isSpoolLoading: false,
			isFillerMaterial1Loading: false,
			isFillerMaterial2Loading: false,
			isPart1Loading: false,
			isPart2Loading: false,

			isProjectStock1Loading: false,
			isProjectStock2Loading: false,

			currentSpool: [],
			currentProjectSetting: [],
			currentWeldMaterial: [],
			currentWelder1: [],
			currentWelder2: [],
			currentWps: [],
			currentFillerMaterial1: [],
			currentFillerMaterial2: [],
			currentPart1: [],
			currentPart2: [],
			currentProjectStock1: [],
			currentProjectStock2: [],

			selectedSpool: null,
			selectedProjectSetting: null,
			selectedWeldMaterial: null,
			selectedWelder1: null,
			selectedWelder2: null,
			selectedWps: null,
			selectedFillerMaterial1: null,
			selectedFillerMaterial2: null,
			selectedPart1: null,
			selectedPart2: null,
			selectedProjectStock1: null,
			selectedProjectStock2: null,

			row: null,
			actionTitle: null,
			tableNameTranslated: Vue.i18n.translate('general.welding.weld.title_modal'),
			tableName: 'weld',

			isReasonLoading: false,
			currentReasonNoSelect: false,
			currentReason: [],
			searchReasonText: Vue.i18n.translate('general.search.type_to_search_setting'),
		}
	},
	computed: {
		weld_places: {
			get: function () {
				let weld_places = this.$store.getters.getWeldPlaces;
				return weld_places;
			}
		},
		part_standard: {
			get: function () {
				let standard = this.$store.getters.getPartStandard;
				return standard;
			}
		}
	},
	watch: {
		model: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
				this.model.repair = Boolean(newVal.repair);
				if (this.model.manual_part_description_1 != null && this.model.manual_part_description_1 != '') {
                    this.currentPart1 = [];
                }

                if (this.model.manual_part_description_2 != null && this.model.manual_part_description_2 != '') {
                    this.currentPart2 = [];
                }
			}
		}
	},
	mounted() {
		this.$refs.rt.load('weld?project_id='+this.$route.params.id+'&filters[parent_weld_id]='+ this.$route.params.id2);
	},
	methods: {
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
		findLastRevisionNumber(request) {
			return new Promise(resolve => {
				http.route(request).get().then(response => {
					if (!response.isError) {
						this.model.revision_number = response.data+1;
					} else {
						this.model.revision_number = null;
					}
					resolve(this.model.revision_number);
				});
			});
		},
		async onAddRow() {
			this.row = null;
			this.model.revision_date           = null;
			this.model.revision_description    = null;
			this.model.revision_reason         = null;
			this.model.revision_reason_setting = null;
			this.model.revision_remarks        = null;

			this.actionTitle = Vue.i18n.translate('general.revision.create_button');
			await this.findLastRevisionNumber('weld/'+this.$route.params.id2+'/maxrevision?project_id='+this.$route.params.id);
			this.$refs.addModal.show();
		},
		onEditRow(row) {
			this.model.drawing_id = row.drawing_id;
			this.row = row;
			this.actionTitle = Vue.i18n.translate('general.revision.edit_button');

			this.model.weld_no                   = row.weld_no;
			this.model.weld_place                = row.weld_place;
			this.model.weld_size                 = row.weld_size;
			this.model.weld_dimension            = row.weld_dimension;
			this.model.weld_standard             = row.weld_standard;
			this.model.project_setting_id        = row.project_setting_id;
			this.model.weld_material_id          = row.weld_material_id;
			this.model.welder_id_1               = row.welder1info ? row.welder1info.id : null;
			this.model.welder_date_1             = row.welder_date_1;
			this.model.welder_id_2               = row.welder2info ? row.welder2info.id : null;
			this.model.welder_date_2             = row.welder_date_2;
			this.model.wps_id                    = row.wps_id;
			this.model.spool_id                  = row.spool_id;
			this.model.filler_material_id_1      = row.filler_material_id_1;
			this.model.filler_material_id_2      = row.filler_material_id_2;
			this.model.part_id_1                    = row.part_id_1;
			this.model.part_id_2                    = row.part_id_2;
			this.model.project_stock_id_1        = row.project_stock_id_1;
			this.model.project_stock_id_2        = row.project_stock_id_2;
			this.model.manual_part_description_1 = row.manual_part_description_1;
			this.model.manual_part_description_2 = row.manual_part_description_2;
			this.model.manual_material_1         = row.manual_material_1;
			this.model.manual_material_2         = row.manual_material_2;
			this.model.manual_certificate_no_1   = row.manual_certificate_no_1;
			this.model.manual_certificate_no_2   = row.manual_certificate_no_2;
			this.model.manual_charge_no_1        = row.manual_charge_no_1;
			this.model.manual_charge_no_2        = row.manual_charge_no_2;
			this.model.manual_manufacturer_1     = row.manual_manufacturer_1;
			this.model.manual_manufacturer_2     = row.manual_manufacturer_2;
			this.model.repair                    = row.repair;
			this.model.rt                        = row.rt;
			this.model.vt                        = row.vt;
			this.model.pt                        = row.pt;
			this.model.ut                        = row.ut;
			this.model.mt                        = row.mt;
			this.model.pmi                       = row.pmi;
			this.model.pwht                      = row.pwht;
			this.model.bht                        = row.bht;
			this.model.at                         = row.at;
			this.model.fn                         = row.fn;
			this.model.others                     = row.others;
			this.model.signature_id_1             = row.signature_id_1;
			this.model.signature_id_2             = row.signature_id_2;
			this.model.signature_id_3             = row.signature_id_3;

			this.selectedWps = row.wps;
			if (this.selectedWps != null) {
				this.model.wpqr = this.selectedWps.wpqr;
			}

			this.selectedProjectSetting  = row.project_setting;
			this.selectedWeldMaterial    = row.weld_material;
			this.selectedWelder1         = (typeof row.welder1info.fullname2 != 'undefined' && row.welder1info.fullname2 != '') ? row.welder1info : null;
			this.selectedWelder2         = (typeof row.welder2info.fullname2 != 'undefined' && row.welder2info.fullname2 != '') ? row.welder2info : null;
			this.selectedSpool           = row.spool;
			this.selectedFillerMaterial1 = row.filler_material1;
			this.selectedFillerMaterial2 = row.filler_material2;
			this.selectedPart1           = row.part1;
			this.selectedPart2           = row.part2;
			this.selectedProjectStock1   = row.stock1;
			this.selectedProjectStock2   = row.stock2;

			this.model.revision_number         = row.revision_number;
			this.model.revision_date           = row.revision_date;
			this.model.revision_description    = row.revision_description;
			this.model.revision_reason         = row.revision_reason;
			this.model.revision_reason_setting = row.revision_reason_setting;
			this.model.revision_remarks        = row.revision_remarks;

			this.$refs.editModal.show();
		},
		saveAction(e) {
			e.preventDefault();
			
			if (this.model.revision_reason_setting == null) {
				this.model.revision_reason_setting = { 'id': null }
			}

			let data = {
				project_id: this.$route.params.id,
				weld_no: this.model.weld_no,
				weld_place: this.model.weld_place,
				weld_size: this.model.weld_size,
				weld_dimension: this.model.weld_dimension,
				weld_standard: this.model.weld_standard,
				project_setting_id: this.model.project_setting_id,
				weld_material_id: this.model.weld_material_id,
				welder_id_1: this.model.welder_id_1,
				welder_date_1: this.model.welder_date_1,
				welder_id_2: this.model.welder_id_2,
				welder_date_2: this.model.welder_date_2,
				wps_id: this.model.wps_id,
				spool_id: this.model.spool_id,
				filler_material_id_1: this.model.filler_material_id_1,
				filler_material_id_2: this.model.filler_material_id_2,
				part_id_1: this.model.part_id_1,
				part_id_2: this.model.part_id_2,
				project_stock_id_1: this.model.project_stock_id_1,
				project_stock_id_2: this.model.project_stock_id_2,
				repair: this.model.repair,
				manual_part_description_1: this.model.manual_part_description_1,
				manual_part_description_2: this.model.manual_part_description_2,
				manual_material_1: this.model.manual_material_1,
				manual_material_2: this.model.manual_material_2,
				manual_certificate_no_1: this.model.manual_certificate_no_1,
				manual_certificate_no_2: this.model.manual_certificate_no_2,
				manual_charge_no_1: this.model.manual_charge_no_1,
				manual_charge_no_2: this.model.manual_charge_no_2,
				manual_manufacturer_1: this.model.manual_manufacturer_1,
				manual_manufacturer_2: this.model.manual_manufacturer_2,
				rt: this.model.rt,
				vt: this.model.vt,
				pt: this.model.pt,
				ut: this.model.ut,
				mt: this.model.mt,
				pmi: this.model.pmi,
				pwht: this.model.pwht,
				bht: this.model.bht,
				at: this.model.at,
				fn: this.model.fn,
				others: this.model.others,
				signature_id_1: this.model.signature_id_1,
				signature_id_2: this.model.signature_id_2,
				signature_id_3: this.model.signature_id_3,

				revision_number: this.model.revision_number,
				revision_remarks: this.model.revision_remarks,
				revision_reason: this.model.revision_reason_setting.id,
				revision_description: this.model.revision_description,
				revision_date: this.model.revision_date,

				id: this.model.id,
				from_revision_control: 1,
			}

			Object.keys(data).forEach(key => {
				if (data[key] === '') {
					data[key] = null;
				}
			});

			if (this.row) {
				data['date'] = data.date ? data.date : null;
				data['id'] = this.$route.params.id2;
				http.route('weld/' + this.row.id).patch(data, true).then(response => {
					if (!response.isError) {
						this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
						this.$refs.rt.refresh();
						this.$refs.editModal.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			} else {
				data['id'] = this.$route.params.id2;
				http.route("weld").post(data, true).then(response => {
					if (!response.isError) {
						this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
						let id = response.data.id;
						this.$refs.rt.refresh();
						this.$refs.addModal.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			}
		},
		onDeleteRow(row, index) {
			this.actionTitle = Vue.i18n.translate('general.revision.delete_button');
			this.row = row;
			this.$refs.deleteModal.show();
		},
		deleteAction (button) {
			if (button == 1) {
				let data = http.route(this.tableName + '/' + this.row.id).delete();
				data.then(response => {
					if (!response.isError) {
						this.$refs.rt.refresh(-1);
						this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
					} else {
						this.errorMsg(Vue.i18n.translate('errors.error_delete'));
					}
				});
			}
			this.$refs.deleteModal.hide();
		},
		onReturn() {
			this.$router.go(-1);
		},
		onSpoolSearch(search) {
			if (search == '') {
				this.currentSpool = [];
				
				return false;
			}

			this.isSpoolLoading = true;
			this.searchSpool(search, this);
		},
		searchSpool: _.debounce((search, vm) => {
			let data = http.route('spool?project_id='+vm.$route.params.id +'&drawing_id='+(vm.model.drawing_id?vm.model.drawing_id:'')+ '&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentSpool = response.data;
				}
				vm.isSpoolLoading = false;
			});
		}, 500),
		updateSpool(spool) {
			this.model.spool_id = (spool != null) ? spool.id : null;
		},
		clearSelectedSpool () {
			this.selectedSpool  = null;
			this.model.spool_id = null;
		},
		onProjectSettingSearch(search) {
			if (search == '') {
				this.currentProjectSetting = [];
				
				return false;
			}

			this.isProjectSettingLoading = true;
			this.searchProjectSetting(search, this);
		},
		searchProjectSetting: _.debounce((search, vm) => {
			let data = http.route('projectsetting?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search + '&filters[type]=weld_type').get();
			data.then(response => {
				if (response.data != false) {
					vm.currentProjectSetting = response.data;
				}
				vm.isProjectSettingLoading = false;
			});
		}, 500),
		updateProjectSetting(project_setting) {
			this.model.project_setting_id = (project_setting != null) ? project_setting.id : null;
		},
		clearSelectedProjectSetting () {
			this.selectedProjectSetting   = null;
			this.model.project_setting_id = null;
		},
		onWeldMaterialSearch(search) {
			if (search == '') {
				this.currentWeldMaterial = [];
				
				return false;
			}

			this.isWeldMaterialLoading = true;
			this.searchWeldMaterial(search, this);
		},
		searchWeldMaterial: _.debounce((search, vm) => {
			let data = http.route('projectsetting?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search + '&filters[type]=weld_material').get();
			data.then(response => {
				if (response.data != false) {
					vm.currentWeldMaterial= response.data;
				}
				vm.isWeldMaterialLoading = false;
			});
		}, 500),
		updateWeldMaterial(weld_material) {
			this.model.weld_material_id = (weld_material != null) ? weld_material.id : null;
		},
		clearSelectedWeldMaterial () {
			this.selectedWeldMaterial   = null;
			this.model.weld_material_id = null;
		},
		onWelder1Search(search) {
			if (search == '') {
				this.currentWelder1 = [];
				
				return false;
			}

			this.isWelder1Loading = true;
			this.searchWelder1(search, this);
		},
		searchWelder1: _.debounce((search, vm) => {
			let data = http.route('user/getall?project_id='+vm.$route.params.id+'&get_all_welders=1&search_select=' + search + '&filters[is_welder]=1').get();
			data.then(response => {
				if (response.data != false) {
					vm.currentWelder1 = response.data;
				}
				vm.isWelder1Loading = false;
			});
		}, 500),
		updateWelder1(welder1) {
			this.model.welder_id_1 = (welder1 != null) ? welder1.id : null;
		},
		clearSelectedWelder1 () {
			this.selectedWelder1     = null;
			this.model.welder_id_1   = null;
			this.model.welder_date_1 = null;
		},
		onWelder2Search(search) {
			if (search == '') {
				this.currentWelder2 = [];
				
				return false;
			}

			this.isWelder2Loading = true;
			this.searchWelder2(search, this);
		},
		searchWelder2: _.debounce((search, vm) => {
			let data = http.route('user/getall?project_id='+vm.$route.params.id+'&get_all_welders=1&search_select=' + search + '&filters[is_welder]=1').get();
			data.then(response => {
				if (response.data != false) {
					vm.currentWelder2 = response.data;
				}
				vm.isWelder2Loading = false;
			});
		}, 500),
		updateWelder2(welder2) {
			this.model.welder_id_2 = (welder2 != null) ? welder2.id : null;
		},
		clearSelectedWelder2 () {
			this.selectedWelder2     = null;
			this.model.welder_id_2   = null;
			this.model.welder_date_2 = null;
		},
		onWpsSearch(search) {
			if (search == '') {
				this.currentWps = [];
				
				return false;
			}

			this.isWpsLoading = true;
			this.searchWps(search, this);
		},
		searchWps: _.debounce((search, vm) => {
			let data = http.route('wps?filters[company_id]=' + vm.$store.state.userSelectedRole.company_id + '&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentWps = response.data;
				}
				vm.isWpsLoading = false;
			});
		}, 500),
		updateWps(wps) {
			this.model.wps_id = (wps != null) ? wps.id : null;
			this.model.wpqr   = (wps != null) ? wps.wpqr : null;
		},
		clearSelectedWps () {
			this.selectedWps  = null;
			this.model.wps_id = null;
			this.model.wpqr   = null;
		},
		onFillerMaterial1Search(search) {
			if (search == '') {
				this.currentFillerMaterial1 = [];
				
				return false;
			}

			this.isFillerMaterial1Loading = true;
			this.searchFillerMaterial1(search, this);
		},
		searchFillerMaterial1: _.debounce((search, vm) => {
			let data = http.route('fillermaterial?project_id='+vm.$route.params.id+'&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentFillerMaterial1 = response.data;
				}
				vm.isFillerMaterial1Loading = false;
			});
		}, 500),
		updateFillerMaterial1(filler_material1) {
			this.model.filler_material_id_1 = (filler_material1 != null) ? filler_material1.id : null;
		},
		clearSelectedFillerMaterial1 () {
			this.selectedFillerMaterial1    = null;
			this.model.filler_material_id_1 = null;
		},
		onFillerMaterial2Search(search) {
			if (search == '') {
				this.currentFillerMaterial2 = [];
				
				return false;
			}

			this.isFillerMaterial2Loading = true;
			this.searchFillerMaterial2(search, this);
		},
		searchFillerMaterial2: _.debounce((search, vm) => {
			let data = http.route('fillermaterial?project_id='+vm.$route.params.id+'&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentFillerMaterial2 = response.data;
				}
				vm.isFillerMaterial2Loading = false;
			});
		}, 500),
		updateFillerMaterial2(filler_material2) {
			this.model.filler_material_id_2 = (filler_material2 != null) ? filler_material2.id : null;
		},
		clearSelectedFillerMaterial2 () {
			this.selectedFillerMaterial2    = null;
			this.model.filler_material_id_2 = null;
		},
		onPart1Search(search) {
			if (search == '') {
				this.currentPart1 = [];
				
				return false;
			}

			this.isPart1Loading = true;
			this.searchPart1(search, this);
		},
		searchPart1: _.debounce((search, vm) => {
			let data = http.route('project_part?project_id='+vm.$route.params.id+'&drawing_id='+vm.$route.params.id2+'&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentPart1 = response.data;
				}
				vm.isPart1Loading = false;
			});
		}, 500),
		updatePart1(part1) {
			this.model.part_id_1 = (part1 != null) ? part1.id : null;
		},
		clearSelectedPart1 () {
			this.selectedPart1   = null;
			this.model.part_id_1 = null;
			this.clearSelectedProjectStock1();
		},
		onPart2Search(search) {
			if (search == '') {
				this.currentPart2 = [];
				
				return false;
			}

			this.isPart2Loading = true;
			this.searchPart2(search, this);
		},
		searchPart2: _.debounce((search, vm) => {
			let data = http.route('project_part?project_id='+vm.$route.params.id+'&drawing_id='+vm.$route.params.id2+'&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentPart2 = response.data;
				}
				vm.isPart2Loading = false;
			});
		}, 500),
		updatePart2(part2) {
			this.model.part_id_2 = (part2 != null) ? part2.id : null;
		},
		clearSelectedPart2 () {
			this.selectedPart2   = null;
			this.model.part_id_2 = null;
			this.clearSelectedProjectStock2();
		},
		onProjectStock1Search(search) {
			if (search == '') {
				this.currentProjectStock1 = [];
				
				return false;
			}

			this.isProjectStock1Loading = true;
			this.searchProjectStock1(search, this);
		},
		searchProjectStock1: _.debounce((search, vm) => {
			let data = http.route('drawing_used?project_id='+vm.$route.params.id+'&drawing_id='+vm.$route.params.id2+'&filters[project_part_id]='+vm.model.part_id_1+'&filters[status]=picked_up&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentProjectStock1 = response.data;
				}
				vm.isProjectStock1Loading = false;
			});
		}, 500),
		updateProjectStock1(project_stock1) {
			this.model.project_stock_id_1 = (project_stock1 != null) ? project_stock1.id : null;
		},
		clearSelectedProjectStock1 () {
			this.selectedProjectStock1    = null;
			this.model.project_stock_id_1 = null;
		},
		onProjectStock2Search(search) {
			if (search == '') {
				this.currentProjectStock2 = [];
				
				return false;
			}

			this.isProjectStock2Loading = true;
			this.searchProjectStock2(search, this);
		},
		searchProjectStock2: _.debounce((search, vm) => {
			let data = http.route('drawing_used?project_id='+vm.$route.params.id+'&drawing_id='+vm.$route.params.id2+'&filters[project_part_id]='+vm.model.part_id_2+'&filters[status]=picked_up&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentProjectStock2 = response.data;
				}
				vm.isProjectStock2Loading = false;
			});
		}, 500),
		updateProjectStock2(project_stock2) {
			this.model.project_stock_id_2 = (project_stock2 != null) ? project_stock2.id : null;
		},
		clearSelectedProjectStock2 () {
			this.selectedProjectStock2    = null;
			this.model.project_stock_id_2 = null;
		},
		onReasonSearch(search) {
			if (search == '') {
				this.currentReason = [];
				
				return false;
			}

			this.isReasonLoading = true;
			this.searchReason(search, this);
		},
		searchReason: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=reason_for_revision&get_all=1&search_select=" + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentReason = response.data;
				}
				vm.isReasonLoading = false;
			});
		}, 500),
		clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/welding/welds/weld_revisioncontrol.vue